import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { RadioButtonGroup } from '@sumup/circuit-ui';
import { useTranslation } from 'react-i18next';
import { InputRow, InputCol } from '../../input';
import { PAYMENT_METHODS } from '../../../constants';
import { getDefaultPaymentMethodType } from '../defaultPaymentMethodType';

const StyledRangedButtons = styled(RadioButtonGroup)`
	${({ theme }) => `
		border: none;
		padding-left: 0;
		margin: 0;
		margin-bottom: ${theme.spacings.mega};
		& > div {
			margin-bottom: ${theme.spacings.mega};
		}
	`}
`;

const PaymentMethodSelector = ({
	onChange,
	initialValue = PAYMENT_METHODS.creditCard,
	availablePaymentMethods,
	businessAccountEnabled,
}) => {
	const { t } = useTranslation();
	const { directDebit, businessAccount, suPayout, suPaymentMethods, suBusinessAccount } = availablePaymentMethods;
	const [value, setValue] = useState(() => getDefaultPaymentMethodType(
		availablePaymentMethods,
		initialValue,
	));

	return <div data-testid="payment-method-selector">
		<InputRow>
			<InputCol>
				<StyledRangedButtons
					hideLabel
					label={t('payment_method.choose_payment_method')}
					name="payment-method-selector"
					value={value}
					onChange={({ target }) => {
						setValue(target.value);
						onChange(target.value);
					}}
					options={[
						...(suPaymentMethods ? [{
							label: t('payment_method.su_payment_methods.label'),
							description: value === PAYMENT_METHODS.suPaymentMethods
								? t('payment_method.su_payment_methods.description')
								: undefined,
							value: PAYMENT_METHODS.suPaymentMethods,
							'data-testid': 'su-payment-method',
						}] : []),
						...(suBusinessAccount ? [{
							label: t('payment_method.su_business_account.label'),
							value: PAYMENT_METHODS.suBusinessAccount,
							'data-testid': 'su-business-account',
						}] : []),
						...(suPayout ? [{
							label: t('payment_method.payout.label'),
							value: PAYMENT_METHODS.suPayout,
							'data-testid': 'payout-payment-method',
						}] : []),
						{
							label: t('payment_method.credit_card.label'),
							value: PAYMENT_METHODS.creditCard,
							'data-testid': 'credit-card-payment-method',
						},
						...(directDebit ? [{
							label: t('payment_method.direct_debit.label'),
							value: PAYMENT_METHODS.directDebit,
							'data-testid': 'direct-debit-payment-method',
						}] : []),
						...(businessAccount ? [{
							label: t('payment_method.business_account.label'),
							value: PAYMENT_METHODS.businessAccount,
							'data-testid': 'business-account-payment-method',
							disabled: !businessAccountEnabled,
						}] : [])
					]}
				/>
			</InputCol>
		</InputRow>
	</div>;
};

PaymentMethodSelector.propTypes = {
	onChange: PropTypes.func.isRequired,
	initialValue: PropTypes.string,
};

export default  PaymentMethodSelector;
